import React from 'react'
import QRCode from 'qrcode.react'
import Barcode from 'react-barcode'
import { Conditional } from '@resurs/react-utils'
import { getText } from '../../../internal/TextLabels'

export const BarQRCode = ({ accountNumber, style = {} }) => (
  <div
    style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      ...style,
    }}
  >
    <Conditional when={!accountNumber.toUpperCase().includes('X')}>
      <div style={{ margin: '0.5rem 3rem' }}>
        <QRCode value={accountNumber} />
      </div>
      <Barcode
        value={accountNumber}
        format="CODE128"
        fontSize={30}
        width={2}
        height={80}
        textPosition="top"
        textMargin={5}
      />
    </Conditional>

    <Conditional when={accountNumber.toUpperCase().includes('X')}>
      <strong style={{ color: '#444', margin: 'auto' }}>
        {getText('payApply.accountInformation.maskedCard')}
      </strong>
    </Conditional>
  </div>
)
